/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FleetsWithOperatingAreasCommonQueryVariables = Types.Exact<{
  regionId?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type FleetsWithOperatingAreasCommonQuery = {
  __typename?: 'Query'
  fleets: {
    __typename?: 'FleetsResponse'
    fleets: Array<{
      __typename?: 'Fleet'
      id: string
      operatingArea: { __typename?: 'OperatingArea'; id: string } | null
    }>
  }
}

export const FleetsWithOperatingAreasCommonDocument = gql`
    query FleetsWithOperatingAreasCommon($regionId: String) {
  fleets(regionId: $regionId) {
    fleets {
      id
      operatingArea {
        id
      }
    }
  }
}
    `

/**
 * __useFleetsWithOperatingAreasCommonQuery__
 *
 * To run a query within a React component, call `useFleetsWithOperatingAreasCommonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetsWithOperatingAreasCommonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetsWithOperatingAreasCommonQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useFleetsWithOperatingAreasCommonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >(FleetsWithOperatingAreasCommonDocument, options)
}
export function useFleetsWithOperatingAreasCommonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >(FleetsWithOperatingAreasCommonDocument, options)
}
// @ts-ignore
export function useFleetsWithOperatingAreasCommonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FleetsWithOperatingAreasCommonQuery,
  FleetsWithOperatingAreasCommonQueryVariables
>
export function useFleetsWithOperatingAreasCommonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetsWithOperatingAreasCommonQuery,
        FleetsWithOperatingAreasCommonQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FleetsWithOperatingAreasCommonQuery | undefined,
  FleetsWithOperatingAreasCommonQueryVariables
>
export function useFleetsWithOperatingAreasCommonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetsWithOperatingAreasCommonQuery,
        FleetsWithOperatingAreasCommonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FleetsWithOperatingAreasCommonQuery,
    FleetsWithOperatingAreasCommonQueryVariables
  >(FleetsWithOperatingAreasCommonDocument, options)
}
export type FleetsWithOperatingAreasCommonQueryHookResult = ReturnType<
  typeof useFleetsWithOperatingAreasCommonQuery
>
export type FleetsWithOperatingAreasCommonLazyQueryHookResult = ReturnType<
  typeof useFleetsWithOperatingAreasCommonLazyQuery
>
export type FleetsWithOperatingAreasCommonSuspenseQueryHookResult = ReturnType<
  typeof useFleetsWithOperatingAreasCommonSuspenseQuery
>
export type FleetsWithOperatingAreasCommonQueryResult = Apollo.QueryResult<
  FleetsWithOperatingAreasCommonQuery,
  FleetsWithOperatingAreasCommonQueryVariables
>
